import { render, staticRenderFns } from "./ChannelBarChart.vue?vue&type=template&id=6e130b92"
import script from "./ChannelBarChart.vue?vue&type=script&lang=js"
export * from "./ChannelBarChart.vue?vue&type=script&lang=js"
import style0 from "./ChannelBarChart.vue?vue&type=style&index=0&id=6e130b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports